import React, {forwardRef, useEffect, useState} from "react";
import i18next from "i18next";
import {
    getFileName,
    getImagePathWithTheme,
    imgPathPerfix,
    isDarkMode,
    isNoteElement,
    isString
} from "../../../../../src/utils";
import {getBoardById, getNoteById, getPageCacheById} from "../../../../../model";
import {PROJECT_ID} from "../../../../../src/views/Draw/DrawIndex";
import { message } from "antd";
import {findNodeWithParents, loop, loopAllNode} from "../../../../../src/TreeUtils";
import {ipcInvoke} from "../../../../../src/common/ipc";
import {
    ARRAY_DEFAULT_PROJECT_ITEM_THUMB_BIG,
    getNoteElementStrokeColor250724,
    KEY_FILE_DIR, PROJECT_THUMB_DEFAULT_HEIGHT, PROJECT_THUMB_W_H
} from "../../../../../src/Const";
import {mutateElement} from "../../element/mutateElement";
import {APP_WEB} from "../../../../../src/electron_interactive";
import {getShareFileUrl} from "../../../../../src/api/Aws";
import Global from "../../../../../src/global";

const EmbedProject = forwardRef((props:{appState:any,element:any,onMouseDown:any,onMouseUp:any,onWheel:any,onAction:any}, ref)=>{
    const [isHover,setIsHover] = useState(false);
    const [refProjectInfo,setRefProjectInfo] = useState<any>({name:'',boardCount:0,cardCount:0,isDeleted:false,isBoardDeleted:false});

    useEffect(()=>{

        if (props.element){
            window.refreshList['embedProject_'+props.element?.id] = refreshData;
        }

        return ()=>{
            delete window.refreshList['embedProject_'+props.element?.id];
        }

    },[props.element]);

    useEffect(() => {
        refreshData();
    }, [props.element?.customData]);

    /**
     * 刷新数据...
     */
    const refreshData = ()=>{
        getNoteById(props.element.customData?.projectId).then(async (project:any)=>{
            if (project == null || project.isDeleted == 1){
                setRefProjectInfo({
                    isDeleted:true
                })
            }else{
                let szProjectName = project.name;
                let szBoardName = '';
                let nCardCount = 0;

                let jDoc = (project.doc);
                if (isString(project.doc)){
                    jDoc = JSON.parse(project.doc);
                }
                let bIsBoardDeleted = false;
                //判断图片是否存在...
                let szThumUrl = '';
                if (!ARRAY_DEFAULT_PROJECT_ITEM_THUMB_BIG.includes(project.thumbUrl)){
                    szThumUrl = project.thumbUrl;
                    if (szThumUrl == "init_info_0.png"){
                        szThumUrl = imgPathPerfix() + szThumUrl;
                    }
                }


                if (props.element.customData?.boardId){
                    let bFind = false;
                    loop(jDoc.canvas,props.element.customData?.boardId,(firstBoard, i, data, parent)=>{
                        //找文件夹.
                        const parents = findNodeWithParents(jDoc.canvas,props.element.customData?.boardId);
                        let szFolderNames = '';
                        if (parents){
                            for (let pp =0;pp<parents.parents.length;pp++){
                                szFolderNames += parents.parents[pp].title + ' > ';
                            }
                        }
                        if (PROJECT_ID == project.id || Global.g_currentSharedProjectId == project.id){
                            //同一个project
                            szProjectName = /*i18next.t("Current project") + " > " + */ szFolderNames + firstBoard.title;
                        }else{
                            szProjectName = project.name + " > " + szFolderNames //+ firstBoard.title;
                        }
                        szBoardName = firstBoard.title;
                        nCardCount = firstBoard.drawJson.elements.filter(p=>isNoteElement(p)).length;
                        szThumUrl = firstBoard.thumbUrl;//缩略图.
                        bFind = true;
                    })

                    if (!bFind){
                        bIsBoardDeleted = true;
                    }else{
                        //取一遍url
                        const board = await getBoardById(props.element.customData?.boardId);
                        if (board?.thumbUrl){
                            szThumUrl = board.thumbUrl;
                            if (ARRAY_DEFAULT_PROJECT_ITEM_THUMB_BIG.includes(szThumUrl)){
                                szThumUrl = imgPathPerfix() + szThumUrl;
                            }
                        }
                    }

                    // const firstBoard = jDoc.canvas.find(p=>p.key == props.element.customData?.boardId)
                    // if (firstBoard){
                    //     if (PROJECT_ID == project.id){
                    //         //同一个project
                    //         szProjectName = i18next.t("Current project") + " > " + firstBoard.title;
                    //     }else{
                    //         szProjectName = project.name + " > " + firstBoard.title;
                    //     }
                    //     nCardCount = firstBoard.drawJson.elements.filter(p=>isNoteElement(p)).length;
                    // }else{
                    //     bIsBoardDeleted = true;
                    // }
                }else{
                    loopAllNode(jDoc.canvas,(item)=>{
                        if (item.drawJson?.elements){
                            nCardCount += item.drawJson.elements.filter(pp=>isNoteElement(pp)).length;
                        }
                    })
                }

                if (APP_WEB){
                    //如果是分享来的，这个缩略图就不要了....没有上传.
                    szThumUrl = '';
                }

                if (szThumUrl){
                    const szFilePath = localStorage.getItem(KEY_FILE_DIR) + getFileName(szThumUrl);
                    const hasFileExist = await ipcInvoke('is-file-exist',{filePath:szFilePath});
                    if (!hasFileExist){
                        //缩略图不存在....
                        const customData = {...props.element.customData};
                        customData.thumbImage = '';
                        props.element.customData.thumbImage = '';
                        mutateElement(props.element, {customData:customData});
                    }else{
                        //如果比例不对的话，也更新.
                        const nW = props.element.width;
                        const nH = props.element.height;
                        if (Math.abs(nH/nW - PROJECT_THUMB_W_H) > 0.1){
                            //需要重新更新高度.
                            mutateElement(props.element, {width:nW,height:nW*PROJECT_THUMB_W_H});
                        }
                    }
                }else{
                    //缩略图不存在....重新计算比例.
                    // const customData = {...props.element.customData};
                    // customData.thumbImage = '';
                    // props.element.customData.thumbImage = '';
                    if (!props.element.customData?.isFixedSize){
                        //没有更改过大小.
                        const nW = props.element.width;
                        const nH = PROJECT_THUMB_DEFAULT_HEIGHT//nW*PROJECT_THUMB_W_H;

                        mutateElement(props.element, {height:nH});
                    }
                }



                setRefProjectInfo({
                    isOK:true,
                    isSameProject:PROJECT_ID == project.id || Global.g_currentSharedProjectId == project.id,
                    name:szProjectName,
                    boardName:szBoardName,
                    thumbUrl:szThumUrl,
                    boardCount:jDoc.canvas.length,
                    cardCount:nCardCount,
                    isDeleted:project.isDeleted == 1,
                    isBoardDeleted:bIsBoardDeleted,
                    hasBoard:props.element.customData?.boardId
                })

                //给外面侧栏打开判断用...
                props.element.customData.isDeleted = project.isDeleted == 1
                props.element.customData.isBoardDeleted = bIsBoardDeleted
            }

        })
    }

    const getProjectDesc = ()=>{
        if (props.element.customData?.boardId){
            return `${refProjectInfo.cardCount} `+i18next.t("GeCards");
        }
        return `${refProjectInfo.boardCount} `+i18next.t('GeBoards') + ', ' +  `${refProjectInfo.cardCount} `+i18next.t("GeCards")
    }


    return (
        <div style={{
            border: (!refProjectInfo.isDeleted && !refProjectInfo.isBoardDeleted)?`none`:'0px solid var(--draw-file-not-exist-border-color)',
            // borderRadius: '8px',
            height: refProjectInfo.thumbUrl?'100%':'calc(100% - 2px)',
            overflow:'hidden',
            display:'flex',
            margin:refProjectInfo.thumbUrl?'0px':'1px',
            zIndex: '2006',
            flexDirection:'column',
            alignItems:'flex-start',
            background:refProjectInfo.thumbUrl?'var(--dialog-dialog-background-color-2c)':props.element.backgroundColor,
            position: 'relative',
            pointerEvents: 'all',
            cursor:'pointer'
        }}
             onMouseEnter={()=>{
                 setIsHover(true)
             }}
             onMouseLeave={()=>{
                 setIsHover(false)
             }}
             onMouseDown={(event) => {
                 props.onMouseDown(event);
             }}
             onMouseUp={(event) => {
                 props.onMouseUp(event);
             }}
             onWheel={(event) => {
                 props.onWheel(event);
             }} onDoubleClick={(event)=>{
                 //双击
                if (!refProjectInfo.isDeleted && !refProjectInfo.isBoardDeleted){
                    props.onAction("doubleClick",props.element)
                }else{
                    message.error(i18next.t('Invalid link'))
                }
             }}>

            {
                refProjectInfo.thumbUrl?<div style={{position:'relative',height:'100%',width:'100%'}}>
                    {
                        <>
                            <img style={{width: '100%', height: 'auto'}} src={APP_WEB?getShareFileUrl(Global.g_currentSharedProjectId,getFileName(refProjectInfo.thumbUrl?.thumbImage)):refProjectInfo.thumbUrl}/>
                            {
                                refProjectInfo.isOK &&
                                <>
                                    <div className={'flex-col'} style={{
                                        position: 'absolute',
                                        left: '0',
                                        bottom: '0',
                                        width: '100%',
                                        background: 'var(--dialog-dialog-background-color-2c)',
                                        padding: '6px 16px',
                                    }}>
                                        {
                                            !refProjectInfo.isSameProject && refProjectInfo.hasBoard && //有board 这里显示项目标题--带着folder
                                            <span style={{
                                                color: 'var(--color-888888)',
                                                marginBottom: '0px',
                                                fontSize: '12px',
                                                marginTop:'4px',
                                            }}>{refProjectInfo.name || i18next.t("Untitled")}</span>
                                        }
                                        <div className={'flex-row-vertical-center mt-6'} style={{paddingBottom:'6px'}}>
                                            <img className={'img-16'} style={{marginTop:'0px'}}
                                                 src={getImagePathWithTheme(refProjectInfo.isSameProject?'library_type_whiteboard':'other_project.svg')}/>
                                            <span className={'ml-6'} style={{
                                                fontSize: '14px',
                                                textAlign: 'left',
                                                marginBottom: '0px',
                                                color: 'var(--text-color-light)'
                                            }}>{refProjectInfo.hasBoard ? refProjectInfo.boardName : refProjectInfo.name}</span>
                                        </div>
                                    </div>
                                </>
                            }
                        </>
                    }

                </div> : <div className={'flex-col'} style={{padding: '20px',}}>
                    {
                        (!refProjectInfo.isDeleted && !refProjectInfo.isBoardDeleted) &&
                        <>
                            {/*这里是显示的信息这里是显示的信息这里是显示的信息这里是显示的信息这里是显示的信息这里是显示的信息这里是显示的信息这里是显示的信息这里是显示的信息这里是显示的信息这里是显示的信息这里是显示的信息这里是显示的信息*/}
                            {
                                !refProjectInfo.isSameProject && refProjectInfo.hasBoard && //有board 这里显示项目标题--带着folder
                                <span style={{
                                    color: 'var(--color-888888)',
                                    marginBottom: '8px'
                                }}>{refProjectInfo.name || i18next.t("Untitled")}</span>
                            }
                            <div className={'flex-row-vertical-center mb-8'}>
                                <img className={'img-16'} style={{marginTop:'-0px'}}
                                     src={getImagePathWithTheme(refProjectInfo.isSameProject ? 'library_type_whiteboard' : 'other_project.svg')}/>
                                <span className={'font-family-semi-bold ml-8'} style={{
                                    fontSize: '18px',
                                    textAlign: 'left',

                                    color: 'var(--text-color)'
                                }}>{refProjectInfo.hasBoard ? refProjectInfo.boardName : refProjectInfo.name}</span>
                            </div>

                            <span style={{color: 'var(--color-888888)',}}>{getProjectDesc()}</span>
                            {
                                // isHover &&
                                // <img className={'img-14 cursor-pointer'} style={{position: 'absolute', right: '16px', top: '16px'}}
                                //      src={getImagePathWithTheme('draw_no_file_close')} onClick={()=>{
                                //     props.onAction("delete",props.element);
                                // }}/>
                            }
                        </>
                    }

                    {
                        refProjectInfo.isDeleted &&
                        <span className={'flex-center'} style={{width:'100%',height:'100%',color:isDarkMode()?'#666666':'#333333'}}>{i18next.t("TheOriginalWhiteboardDeleted")}</span>
                    }

                    {
                        refProjectInfo.isBoardDeleted &&
                        <span className={'flex-center'} style={{width:'100%',height:'100%',color:isDarkMode()?'#666666':'#333333'}}>{i18next.t("TheOriginalBoardDeleted")}</span>
                    }
                </div>
            }

        </div>
    )
})

export default EmbedProject;







































































































































































































































































































































































































































